// extracted by mini-css-extract-plugin
export default {"fontFamily":"CustomerTable_fontFamily__bBmyY","tableBg":"CustomerTable_tableBg__TljhC","h4":"CustomerTable_h4__rw1i2"};